import mutations from './mutations'
import actions from './action'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    personalFilter: {
      fileType: 0,
      listType: 'list'
    },
    enterpriseFilter: {
      fileType: 0,
      listType: 'list'
    },
    projectFilter: {
      fileType: 0,
      listType: 'list'
    }
  },
  getters,
  actions,
  mutations,
  modules: {}
}
